import React from "react";
import { Alert, AlertIcon } from "@chakra-ui/react";
import { FIELD_COMPONENTS } from "../../utils/riskReviewFieldRegistry";

const UnsupportedField = ({ field }) => (
  <Alert status="warning" borderRadius="md">
    <AlertIcon />
    Unsupported Risk Review field type: {field.inputType}
  </Alert>
);

const RiskReviewFieldRenderer = ({ field, control, disabled, error, required, compact, index, requestId }) => {
  const Component = FIELD_COMPONENTS[field.inputType] || UnsupportedField;

  return (
    <Component
      field={field}
      control={control}
      disabled={disabled}
      error={error}
      required={required}
      compact={compact}
      index={index}
      requestId={requestId}
    />
  );
};

export default RiskReviewFieldRenderer;
